(function () {
  var OVERLAY_ID = 'shopify-pc-overlay';
  var DIALOG_SELECTOR = "[id^='shopify-pc__'][role='dialog'], [id^='shopify-pc__'][role='alertdialog']";
  var isActive = false;

  function isVisible(el) {
    if (!el || !el.isConnected || el.hasAttribute('hidden')) return false;
    // getComputedStyle(el).display only reflects the element's own value —
    // "display" doesn't inherit, so a dialog can report "flex" on itself
    // while an ancestor (e.g. the outer #shopify-pc__prefs wrapper) is
    // display:none and hides it entirely. getClientRects() reflects whether
    // the element is actually rendered anywhere in that ancestor chain.
    // visibility DOES inherit, so checking it on the element itself is enough.
    if (window.getComputedStyle(el).visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function getOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = OVERLAY_ID;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function anyDialogVisible() {
    var dialogs = document.querySelectorAll(DIALOG_SELECTOR);
    for (var i = 0; i < dialogs.length; i++) {
      if (isVisible(dialogs[i])) return true;
    }
    return false;
  }

  function sync() {
    var shouldBeActive = anyDialogVisible();

    // Only touch the DOM on an actual state change: classList.add/remove
    // re-writes the "class" attribute even when it's a no-op, which the
    // observer below would pick up as a fresh mutation and re-trigger sync()
    // forever. Guarding on isActive keeps this edge-triggered.
    if (shouldBeActive === isActive) return;
    isActive = shouldBeActive;

    if (isActive) {
      getOverlay().classList.add('is-visible');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    } else {
      var overlay = document.getElementById(OVERLAY_ID);
      if (overlay) overlay.classList.remove('is-visible');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }

  var observer = new MutationObserver(sync);

  function start() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });
    sync();
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
